import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import { convertRGBtoRGBA } from 'utils/colorConvert';
import Popup from 'client/components/Popup';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import usePromoSettingComponentStyle from 'hooks/usePromoSettingComponentStyle';
import { usePopupStyle } from 'styles/common';

export default function PopupWinnerGet({ isOpen, title, onConfirm, btnText, imgSrc, label }) {
    const themeStyle = usePromoSettingThemeStyle();
    const componentStyle = usePromoSettingComponentStyle(themeStyle);
    const style = usePopupStyle(componentStyle);

    return (
        <Popup
            className={style.popup}
            isOpen={isOpen}
            title={title}
            onConfirm={onConfirm}
            endButton={btnText}
            endButtonStyle={style.endButton}
            backdropStyle={{ backgroundColor: convertRGBtoRGBA(themeStyle.contentBgColor, 0.5) }}
        >
            <div css={modalContentStyle}>
                {Boolean(imgSrc) && <img css={prizeImageStyle} src={imgSrc} alt={label} />}
                <Typography
                    variant="subtitle2"
                    css={prizeTextStyle(componentStyle?.popupTextColor)}
                >
                    {label}
                </Typography>
            </div>
        </Popup>
    );
}

const modalContentStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const prizeImageStyle = css`
    width: auto;
    max-width: 160px;
    max-height: 400px;
`;

const prizeTextStyle = popupTextColor => css`
    padding: 8px 16px;
    text-align: center;
    color: ${popupTextColor};
`;
